import { Navigate, useLocation } from "react-router-dom";

const getDefaultRoute = (type) => {
  switch (type) {
    case "admin":
      return "/bill";
    case "agent":
      return "/bill";
    case "kitchen":
      return "/home";
    case "inventory":
      return "/inventory";
    default:
      return "/";
  }
};

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const type = localStorage.getItem("type");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (type === "admin" || type === "agent") {
    return children;
  }

  if (type === "kitchen") {
    const kitchenRoutes = [
      "/home",
      "/void-today",
      "/report",
      "/items-report",
    ];

    if (!kitchenRoutes.includes(location.pathname)) {
      return <Navigate to="/home" replace />;
    }
  }

  if (type === "inventory") {
    const inventoryRoutes = [
      "/inventory",
      "/detailedpurchasereport",
      "/statement",
      "/costcenter",
      "/items",
      "/detail",
      "/show-all-chart",
      "/menu",
      "/itemdata",
      "/additemunit",
      "/menuitemcost",
      "/viewrecipeitems",
      "/viewunitdefinitions",
      "/subrecipecost",
      "/viewsubrecipes",
      "/menuengineering",
      "/inventorycalculation",
      "/inventoryreceived",
      "/addopeningcount",
      "/add-wastage",
      "/inventoryhistory",
      "/addphysicalcount",
      "/costinganalysis",
      "/purchase-entry",
      "/receive-purchase",
      "/order-history",
      "/item-expiry",
      "/create-store-req",
      "/store-reqs",
      "/wastage-report",
      "/central-kitchen/production",
      "/central-kitchen/production-history",
      "/central-kitchen/conversion-factor",
      "/central-kitchen/inventory-calculator",
      "/central-kitchen/wastage",
      "/central-kitchen/opening-count",
      "/central-kitchen/physical-count",
    ];

    if (!inventoryRoutes.includes(location.pathname)) {
      return <Navigate to="/inventory" replace />;
    }
  }

  if (type === "reservation") {
    const reservationRoutes = [
      "/branch/page",
      "/branch/tables",
      "/branch/reservations",
      "/branch/blocked-dates",
      "/branch/mail-recipents",
    ];

    if (!reservationRoutes.includes(location.pathname)) {
      return <Navigate to="/branch/reservations" replace />;
    }
  }

  return children;
};

export const createProtectedRoute = (path, component, props = {}) => ({
  path,
  element: <ProtectedRoute>{component}</ProtectedRoute>,
  ...props
});

export const handleUnknownRoute = () => {
  const token = localStorage.getItem("token");
  const type = localStorage.getItem("type");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={getDefaultRoute(type)} replace />;
};